import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import { Type } from "@themes/pollinator/ui/Type";
import { ProgramQuizFormContainer } from "@platform/features/programQuiz";

export type Props = {
  /** Quiz ID for the matching quiz */
  quizId?: number;
  /** Callback when quiz is saved */
  onSaveSuccess: () => void;
  /** When true, shows the form in read-only mode */
  isReadOnly?: boolean;
};

/**
 * Matching Form tab content.
 * Contains the matching quiz form.
 */
export function ProfileMatchingFormTab({ quizId, onSaveSuccess, isReadOnly = false }: Props) {
  if (!quizId) {
    return (
      <div
        className="w-full flex flex-col gap-8 pb-8 max-w-3xl"
        data-testid="profile-matching-form-tab"
      >
        <Type variant="body1" className="text-brand-700">No matching quiz available.</Type>
      </div>
    );
  }

  const title = "Matching Survey";
  const description = isReadOnly
    ? "Matching has been completed. Your responses are shown below."
    : "Answer these questions to help us match you with an aligned peer cohort.";

  return (
    <div
      className="w-full flex flex-col gap-8 pb-8 max-w-3xl"
      data-testid="profile-matching-form-tab"
    >
      <SectionHeading
        title={title}
        description={description}
      >
        <ProgramQuizFormContainer
          quizId={quizId}
          resourceName={title}
          onSaveSuccess={onSaveSuccess}
          isReadOnly={isReadOnly}
          className="w-full flex flex-col gap-6"
        />
      </SectionHeading>
    </div>
  );
}

export default ProfileMatchingFormTab;
